import { createStyles } from '../withStyles';
const styles = createStyles({
    icon: {
        height: 20,
        width: 20,
        fill: 'currentColor',
        flexShrink: 0,
    },
});
export default styles;
//# sourceMappingURL=Icon.styles.js.map